module.exports = __webpack_public_path__ + "7dfe83d20b3001ffe9a78f4126fa1f92.svg";